import React, { useContext } from 'react';
import type { PrismicSliceArticleCarousel } from 'src/types';
import {
  ArticleCarouselContainer,
  ArticlePreviewCard,
  ArticlePreviewCardMedia,
  ArticlePreviewCardContent,
  EllipsisSmallText,
  ReadMoreLink,
} from './styles';
import { CardTitle } from 'src/areas/expert/styles';
import { MediumCardHorizontalScroll } from 'src/components/horizontal-scroll/variants/medium-card-horizontal-scroll';
import { plainText } from '../rich-text';
import { AppContext } from 'src/components/app-context';
import { Clickable } from 'src/components/clickable';

type Props = Pick<PrismicSliceArticleCarousel, 'articles'>;

const ArticleCarousel = ({ articles }: Props) => {
  const { t } = useContext(AppContext);

  return (
    <ArticleCarouselContainer>
      <MediumCardHorizontalScroll>
        {articles.map(article => {
          return (
            <ArticlePreviewCard key={article.id}>
              <ArticlePreviewCardMedia>
                <img src={article.image.url} alt={article.image.alt || ''} />
              </ArticlePreviewCardMedia>
              <ArticlePreviewCardContent>
                <CardTitle>{plainText(article.title)}</CardTitle>
                {article.preamble && (
                  <EllipsisSmallText>
                    {plainText(article.preamble)}
                  </EllipsisSmallText>
                )}

                <ReadMoreLink
                  container={Clickable}
                  containerProps={{
                    isExternal: false,
                    to: `${article.slugs.join('/')}--ec${article.id}`,
                  }}
                >
                  {t('landing', 'featured-article.read-more')}
                </ReadMoreLink>
              </ArticlePreviewCardContent>
            </ArticlePreviewCard>
          );
        })}
      </MediumCardHorizontalScroll>
    </ArticleCarouselContainer>
  );
};

export default ArticleCarousel;
